import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    height="1em"
    viewBox="0 -53 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m268.878906 0h-25.757812c-22.757813 0-41.207032 18.449219-41.207032 41.207031v87.921875h108.171876v-87.921875c0-22.757812-18.449219-41.207031-41.207032-41.207031zm0 0"
      fill="#01cef0"
    />
    <path
      d="m268.878906 0h-25.757812c-1.300782 0-2.585938.0664062-3.855469.183594 20.949219 1.945312 37.351563 19.566406 37.351563 41.023437v87.921875h33.46875v-87.921875c0-22.757812-18.449219-41.207031-41.207032-41.207031zm0 0"
      fill="#1cb4d6"
    />
    <path
      d="m481.09375 406.921875h-450.1875c-17.070312 0-30.90625-13.835937-30.90625-30.90625v-247.242187c0-17.070313 13.835938-30.90625 30.90625-30.90625h450.1875c17.070312 0 30.90625 13.835937 30.90625 30.90625v247.242187c0 17.070313-13.835938 30.90625-30.90625 30.90625zm0 0"
      fill="#e9f3fe"
    />
    <path
      d="m481.09375 97.867188h-54.082031c17.066406 0 30.902343 13.835937 30.902343 30.90625v247.242187c0 17.070313-13.835937 30.90625-30.902343 30.90625h54.082031c17.070312 0 30.90625-13.835937 30.90625-30.90625v-247.242187c0-17.070313-13.835938-30.90625-30.90625-30.90625zm0 0"
      fill="#c9e9f4"
    />
    <path
      d="m228.078125 347.6875h-149.375c-11.378906 0-20.605469-9.226562-20.605469-20.605469v-149.375c0-11.378906 9.226563-20.605469 20.605469-20.605469h149.375c11.378906 0 20.601563 9.226563 20.601563 20.605469v149.375c0 11.378907-9.222657 20.605469-20.601563 20.605469zm0 0"
      fill="#fb6b41"
    />
    <path
      d="m228.078125 157.101562h-42.113281c11.378906 0 20.605468 9.226563 20.605468 20.605469v149.375c0 11.378907-9.226562 20.605469-20.605468 20.605469h42.113281c11.378906 0 20.601563-9.226562 20.601563-20.605469v-149.375c0-11.378906-9.222657-20.605469-20.601563-20.605469zm0 0"
      fill="#e04903"
    />
    <path
      d="m437.40625 203.460938h-118.472656c-11.378906 0-20.601563-9.222657-20.601563-20.605469v-5.148438c0-11.378906 9.222657-20.605469 20.601563-20.605469h118.472656c11.378906 0 20.601562 9.226563 20.601562 20.605469v5.148438c0 11.382812-9.222656 20.605469-20.601562 20.605469zm0 0"
      fill="#015f7f"
    />
    <path
      d="m437.40625 157.101562h-39.800781c11.378906 0 20.605469 9.226563 20.605469 20.605469v5.148438c0 11.382812-9.226563 20.605469-20.605469 20.605469h39.800781c11.378906 0 20.601562-9.222657 20.601562-20.605469v-5.148438c0-11.378906-9.222656-20.605469-20.601562-20.605469zm0 0"
      fill="#014e6a"
    />
    <path
      d="m165.363281 270.421875h-25.753906c-22.757813 0-41.207031 18.449219-41.207031 41.207031v36.058594h108.167968v-36.058594c0-22.757812-18.449218-41.207031-41.207031-41.207031zm0 0"
      fill="#facf39"
    />
    <path
      d="m165.363281 270.421875h-25.753906c-2.238281 0-4.429687.183594-6.570313.527344 19.632813 3.148437 34.636719 20.160156 34.636719 40.679687v36.058594h38.894531v-36.058594c0-22.757812-18.449218-41.207031-41.207031-41.207031zm0 0"
      fill="#eab20b"
    />
    <path
      d="m182.875 214.496094c0 16.78125-13.605469 30.390625-30.390625 30.390625-16.78125 0-30.390625-13.609375-30.390625-30.390625 0-16.785156 13.609375-30.390625 30.390625-30.390625 16.785156 0 30.390625 13.605469 30.390625 30.390625zm0 0"
      fill="#facf39"
    />
    <path
      d="m152.484375 184.105469c-5.351563 0-10.375 1.386719-14.742187 3.816406 9.332031 5.1875 15.648437 15.140625 15.648437 26.574219s-6.316406 21.386718-15.648437 26.574218c4.367187 2.425782 9.390624 3.816407 14.742187 3.816407 16.785156 0 30.390625-13.609375 30.390625-30.390625 0-16.785156-13.605469-30.390625-30.390625-30.390625zm0 0"
      fill="#eab20b"
    />
    <g fill="#015f7f">
      <path d="m416.613281 230.851562h-118.28125c-4.269531 0-7.726562 3.460938-7.726562 7.726563 0 4.269531 3.457031 7.726563 7.726562 7.726563h118.28125c4.269531 0 7.726563-3.457032 7.726563-7.726563 0-4.265625-3.457032-7.726563-7.726563-7.726563zm0 0" />
      <path d="m416.613281 265.972656h-118.28125c-4.269531 0-7.726562 3.457032-7.726562 7.726563 0 4.265625 3.457031 7.726562 7.726562 7.726562h118.28125c4.269531 0 7.726563-3.460937 7.726563-7.726562 0-4.269531-3.457032-7.726563-7.726563-7.726563zm0 0" />
      <path d="m416.613281 301.089844h-118.28125c-4.269531 0-7.726562 3.457031-7.726562 7.726562 0 4.269532 3.457031 7.726563 7.726562 7.726563h118.28125c4.269531 0 7.726563-3.457031 7.726563-7.726563 0-4.269531-3.457032-7.726562-7.726563-7.726562zm0 0" />
    </g>
  </svg>
);

const IconCard = (props) => <Icon component={icon} {...props} />;

export default IconCard;
